import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { ElioHasPermissionModule } from '@elio/emanager-front/shared/directives';
import { isMultipleFilterOption } from '@elio/emanager-front/shared/models';
import { ElioButtonComponent } from '@elio/emanager-front/shared/ui/button';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TooltipModule } from 'primeng/tooltip';
import { FILTERABLE_STORE, FilterableStore, FilterableType } from '../filter.token';
import { ElioFilterAccordionComponent } from './filter-accordion/filter-accordion.component';
import { ElioFilterItemComponent } from './filter-item/filter-item.component';

@Component({
  selector: 'elio-filters',
  templateUrl: './filters.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ElioButtonComponent,
    ElioFilterAccordionComponent,
    ElioFilterItemComponent,
    ElioHasPermissionModule,
    ElioSvgIconsModule,
    LetDirective,
    PushPipe,
    TooltipModule,
    TranslocoModule,
  ],
  host: {
    class: 'flex flex-col flex-grow overflow-auto',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioFiltersComponent<T extends FilterableType> {
  @Input() absolute = true;
  readonly filters$ = this.filterableStore.filtersTree$;

  constructor(@Inject(FILTERABLE_STORE) private filterableStore: FilterableStore<T>) {}

  reset() {
    this.filterableStore.resetfilter();
  }

  isMultipleFilter = isMultipleFilterOption;
}
